<template>
<div class="main-wrapper">
	<div class="popup-wrapper" v-if="!isClosed">
		<div class="popup-dialog">
			<p class="title">打开壹钱包APP</p>
			<div class="btn-box">
				<a href="javascript:;" @click="closePage">取消</a>
				<a href="javascript:;" @click="callApp"><strong>确定</strong></a>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	data() {
		return {
			env: this.tools.single().isBrowserClient(),
			browser: this.tools.single().riskClient(),
			os: this.tools.single().isOSClient(),
			stateParams: this.tools.single().getStateParams(),
			isRedirect: this.tools.single().getUrlParam('isredirect'),
			backUrl: this.tools.single().getUrlParam('backurl'),
			isClosed: false,
			URL: {
		        "ios": {
		            //openUrl: "yiqianbao://",
		            downloadUrl: "https://itunes.apple.com/app/id745097904",
		            urlScheme: "yqbnative://app.1qianbao.com",
		            universalLink: "https://oia.yqb.com/ow"
		        },
		        "android": {
		            //openUrl: "eqianbao://",
		            downloadUrl: "//d.1qianbao.com/youqian/app/1qb_88888.apk",
		            urlScheme: "yqbnative://app.1qianbao.com"
		        },
		        "baseUrl": "//d.1qianbao.com/youqian/",
		        "yybUrl": "http://a.app.qq.com/o/simple.jsp?pkgname=com.paic.zhifu.wallet.activity" //应用宝url地址
		    },
		    evokeConfig: {}
		}
	},
	props: ['tools'],
	methods: {
		closePage() {
			history.go(-1);
			this.isClosed = true;
		},
		callApp(obj) {
			this.stateParams.callType == 'h5' ? this.evokeH5() : this.evokeNative();
		},
		evokeNative(obj) {
	        // 默认为活期首页
	        let defaultOption = {
	            module: "huoqianbao",
	            action: "index",
	            _tpl: "eyJ0cGwiOnsidHBsSWQiOiIxIn0sIm1pblZlcnNpb24iOiIzLjAuMCIsIm1heFZlcnNpb24iOiI5LjkuOSJ9"
	        }
	        let module, action, _tpl, fromApp;
	        let option = (obj && obj.module !== 'undefined' && typeof obj.action !== 'undefined') ? obj : this.stateParams;
	        if (typeof option.module !== 'undefined' && typeof option.action !== 'undefined') {
	            module = option.module;
	            action = option.action;
	            _tpl = option._tpl;
	            fromApp = option.fromApp;
	        } else {
	            module = defaultOption.module;
	            action = defaultOption.action;
	            _tpl = defaultOption._tpl;
	            fromApp = defaultOption.fromApp;
	        }
	        this.evokeConfig = {module, action, _tpl, fromApp, callType: 'native'};
	        this.evokeUp([module, "/", action].join(""), _tpl, fromApp);
	    },
	    evokeH5(obj) {
	        // 默认为默认为活期资产构成
	        let defaultOption = {
	                url: 'http://h5.1qianbao.com/yqbBalance/index.html#/balance/myFundsList', //打开的h5页面url
	                tokenType: '1', //默认为内部登录态
	                contentClass: '', //商户类别,默认为空
	                caller: '', //调用方 默认为空
	                isNativeNav: true //native导航,默认为true 是否有native导航栏 ,false 无native导航栏，true 有native导航栏
	            }
	            // tokenType
	            // 0:无登录态，1:内部登录态, 2:外部登录态, 3:万里通登录态, 4:格瓦拉登录态，5：半内登（内部登录态半登），
	            // 6：五千里通登录态（万里通登录态半登），由其业务决定登录态类型。
	            // 半登录态说明：配置半登后，如果当前有账户登录，将用对应登录态进行加载，如果没有账户登录，将不带登录态加载。
	            // 只有外部登录态tokenType=2的情况下，才有contentClass及caller
	        let tokenType, contentClass, caller, isNativeNav, url, fromApp;
	        let option = (obj && obj.url !== 'undefined' && typeof obj.tokenType !== 'undefined') ? obj : this.stateParams;
	        if (typeof option.url !== 'undefined' && typeof option.tokenType !== 'undefined') {
	            url = option.url;
	            tokenType = option.tokenType;
	            contentClass = typeof option.contentClass === 'undefined' ? '' : option.contentClass;
	            caller = typeof option.caller === 'undefined' ? '' : option.caller;
	            isNativeNav = typeof option.isNativeNav === 'undefined' ? true : option.isNativeNav;
	            fromApp = option.fromApp; // 判断是否在app内部
	        } else {
	            url = defaultOption.url;
	            tokenType = defaultOption.tokenType;
	            contentClass = defaultOption.contentClass;
	            caller = defaultOption.caller;
	            isNativeNav = defaultOption.isNativeNav;
	            fromApp = defaultOption.fromApp;
	        }
	        let config = {
	            "minVersion": "5.0.1",
	            "maxVersion": "",
	            "tpl": {
	                "tplId": "tplId",
	                "tplParams": {
	                    tokenType: tokenType,
	                    contentClass: contentClass,
	                    caller: caller,
	                    isNativeNav: isNativeNav,
	                    url: (obj || typeof this.stateParams.url === 'undefined') ? url : decodeURIComponent(url)
	                }
	            }
	        };
	        this.evokeConfig = {url: encodeURIComponent(url), tokenType, contentClass, caller, isNativeNav, fromApp, callType: 'h5'};
	        this.evokeUp("openUrl/index", this.tools.single().Base64Encode(JSON.stringify(config), false), fromApp);
	    },
	    evokeUp(assembleUrl, _tpl, isFromApp) {
	        let JumpUrl = "",
	            DownloadUrl = "";

            if (this.os == 'ios') {
                //ios9以下
                //alert(db.device.iosVersion);
                let iosVersion = this.tools.single().getIOSVersion();
                if (this.tools.single().compareVersion(iosVersion, "9.0")) {
                    //判断是否在app内部
                    if (isFromApp) {
                        //内部
                        JumpUrl = [this.URL.ios.urlScheme, "/", assembleUrl, "?_tpl=", _tpl].join("");
                    } else {
                        //ios 9 以上,使用universal link 方式唤起, 外部
                        JumpUrl = [this.URL.ios.universalLink, "/", assembleUrl, "?_tpl=", _tpl].join("");
                        if(this.isRedirect) {
                        	JumpUrl = [JumpUrl, '&isredirect=', this.isRedirect, '&backurl=', this.backUrl].join('');
                        }
                    }
                    //iframe无法唤起
                    window.location.href = JumpUrl;
                } else {
                    //ios 9 以下,使用url scheme唤起
                    JumpUrl = [this.URL.ios.urlScheme, "/", assembleUrl, "?_tpl=", _tpl].join("");
                    //
                    this.openApp(JumpUrl, this.isRedirect, function(isOpen) {
                        //alert(isOpen);
                        //唤起之后的回调
                        //!isOpen && (window.location.href = DownloadUrl);
                    });
                }
                DownloadUrl = this.URL.ios.downloadUrl;
            } else if (this.os == 'android') {
                //安卓使用url scheme唤起
                JumpUrl = [this.URL.ios.urlScheme, "/", assembleUrl, "?_tpl=", _tpl].join("");
                DownloadUrl = this.URL.android.downloadUrl;
                //
                this.openApp(JumpUrl, this.isRedirect, function(isOpen) {
                    //alert(isOpen);
                    //唤起之后的回调
                    //!isOpen && (window.location.href = DownloadUrl);
                });
            } else {
                //走base 流程
                window.location.href = this.URL.baseUrl;
            }
	    },
	    openApp(openUrl, isRedirect, callback) {
	        function checkOpen(cb) {
	            var _clickTime = +(new Date());

	            function check(elsTime) {
	                if (elsTime > 3000 || document.hidden || document.webkitHidden) {
	                    cb(1);
	                } else {
	                    cb(0);
	                }
	            }
	            //启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
	            var _count = 0,
	                intHandle;
	            intHandle = setInterval(function() {
	                _count++;
	                var elsTime = +(new Date()) - _clickTime;
	                if (_count >= 100 || elsTime > 3000) {
	                    clearInterval(intHandle);
	                    check(elsTime);
	                }
	            }, 20);
	        }
	        //在iframe 中打开APP
	        var ifr = document.createElement('iframe');
	        ifr.src = openUrl;
	        ifr.style.display = 'none';
	        if (callback) {
	            checkOpen(function(opened) {
	                callback && callback(opened);
	            });
	        }
	        document.body.appendChild(ifr);
	        setTimeout(() => {
				let url = 'https://d.1qianbao.com/activity/h5/evoke/middle.html?';
				let params = [];
				for(let key in this.evokeConfig) {
					this.evokeConfig[key] && params.push(key + '=' + this.evokeConfig[key])
				}
				url = url + params.join('&');
				if(this.isRedirect) {
					url += '&isredirect=' + this.isRedirect + '&backurl=' + this.backUrl;
				}
				window.location.href = url
			}, 500);
	        // setTimeout(function() {
	        //     document.body.removeChild(ifr);
	        // }, 2000);
	    },
	    forDownLoad() {
	        if (this.os == 'ios') {
	            window.location.href = this.URL.ios.downloadUrl;
	        } else if (this.os == 'android') {
	            if (this.env == 'wechat') {
	                window.location.href = this.URL.yybUrl;
	            } else {
	                window.location.href = this.URL.android.downloadUrl;
	            }
	        } else {
	            window.location.href = this.URL.android.baseUrl;
	        }
	    }
	}
}
</script>


// WEBPACK FOOTER //
// App.vue?12c6ae77